import React from 'react'
import './subTituloRes.scss'

const SubTituloResMini = ({nombre}) => {
  return (
    <div className='tituloResumenesMini col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12'>
      <p className='fw-bold mb-1 d-flex mx-3'>{nombre}</p>
    </div>
  )
}

export default SubTituloResMini
